if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      signatureCheckboxListener = null;
      quantityDropdownListener = null;
      quantityDropdownObserver = null;
      currentQuantityDropdown = null;
      paperCheckboxListeners = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.initPaperQuantitiesHandler();
        this.initSignatureCheckboxHandler();
        this.initPaperCheckboxHandlers();
        
        // Initialize price on load
        const variant = this.getSelectedVariant(document);
        if (variant) {
          this.updateCombinedDisplayedPrice(variant);
        }
        
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.cleanupPaperQuantitiesHandler();
        this.cleanupSignatureCheckboxHandler();
        this.cleanupPaperCheckboxHandlers();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
          // Reinitialize handlers after HTML update
          this.initPaperQuantitiesHandler();
          this.initSignatureCheckboxHandler();
          this.initPaperCheckboxHandlers();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
console.log("Selected variant:", variant);


//  ✅ Check variant availability and update Add to Cart button
    const addToCartBtn = this.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    // if (addToCartBtn) {
    //   if (variant && variant.available) {
    //     addToCartBtn.removeAttribute('disabled');
    //     addToCartBtn.textContent = window.variantStrings.addToCart || 'Add to cart';
    //     addToCartBtn.classList.remove('sold-out');
    //   } else {
    //     addToCartBtn.setAttribute('disabled', 'true');
    //     addToCartBtn.textContent = window.variantStrings.soldOut || 'Sold Out';
    //     addToCartBtn.classList.add('sold-out');
    //   }
    // }
     if (addToCartBtn) {
      // Ensure loading spinner exists inside the button (variant swaps sometimes drop inner HTML)
      let spinner = addToCartBtn.querySelector('.loading__spinner');
      if (!spinner) {
        // Try to clone an existing spinner from the page to preserve SVG/content
        const anySpinner = document.querySelector('.loading__spinner');
        if (anySpinner) {
          spinner = anySpinner.cloneNode(true);
        } else {
          // Inject the exact spinner markup if none exists on the page
          spinner = document.createElement('div');
          spinner.className = 'loading__spinner hidden';
          spinner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>';
        }
        addToCartBtn.appendChild(spinner);
      }

      const addToCartLabel = addToCartBtn.querySelector('span');
      if (variant && variant.available) {
        addToCartBtn.removeAttribute('disabled');
        if (addToCartLabel) addToCartLabel.textContent = window.variantStrings.addToCart || 'Add to cart';
        addToCartBtn.classList.remove('sold-out');
      } else {
        addToCartBtn.setAttribute('disabled', 'true');
        if (addToCartLabel) addToCartLabel.textContent = window.variantStrings.soldOut || 'Sold Out';
        addToCartBtn.classList.add('sold-out');
      }
    }

if (variant && typeof this.onVariantChanged === 'function') {
  this.onVariantChanged(variant);
}

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          // After the theme price HTML is swapped, override with combined price if needed
          this.updateCombinedDisplayedPrice(variant);
        };
      }



// handleUpdateProductInfo(productUrl) {
//   return (html) => {
//     const variant = this.getSelectedVariant(html);
//     console.log("Selected variant:", variant);

//     // ✅ Check variant availability and update Add to Cart button
//     const addToCartBtn = this.querySelector(`#ProductSubmitButton-${this.sectionId}`);
//     if (addToCartBtn) {
//       if (variant && variant.available) {
//         addToCartBtn.removeAttribute('disabled');
//         addToCartBtn.textContent = window.variantStrings.addToCart || 'Add to cart';
//         addToCartBtn.classList.remove('sold-out');
//       } else {
//         addToCartBtn.setAttribute('disabled', 'true');
//         addToCartBtn.textContent = window.variantStrings.soldOut || 'Sold Out';
//         addToCartBtn.classList.add('sold-out');
//       }
//     }


//     if (variant && typeof this.onVariantChanged === 'function') {
//       this.onVariantChanged(variant);
//     }

//     this.pickupAvailability?.update(variant);
//     this.updateOptionValues(html);
//     this.updateURL(productUrl, variant?.id);
//     this.updateVariantInputs(variant?.id);

//     if (!variant) {
//       this.setUnavailable();
//       return;
//     }

//     this.updateMedia(html, variant?.featured_media?.id);

//     const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
//       const source = html.getElementById(`${id}-${this.sectionId}`);
//       const destination = this.querySelector(`#${id}-${this.dataset.section}`);
//       if (source && destination) {
//         destination.innerHTML = source.innerHTML;
//         destination.classList.toggle('hidden', shouldHide(source));
//       }
//     };

//     updateSourceFromDestination('price');
//     updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
//     updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
//     updateSourceFromDestination('Volume');
//     updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

//     this.updateQuantityRules(this.sectionId, html);
//     this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
//     this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

//     // Keep default button behavior if variant.available logic not handled elsewhere
//     this.productForm?.toggleSubmitButton(
//       html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
//       window.variantStrings.soldOut
//     );

//     publish(PUB_SUB_EVENTS.variantChange, {
//       data: {
//         sectionId: this.sectionId,
//         html,
//         variant,
//       },
//     });
//   };
// }



      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      // Helpers to handle both sale and non-sale price text nodes
      getPriceNodes() {
        const container = this.querySelector(`#price-${this.dataset.section}`) || this.querySelector('.price');
        if (!container) return [];
        const selectors = [
          '.price-item--sale.price-item--last',
          '.price__sale .price-item--last',
          '.price__regular .price-item--regular',
          '.price-item--regular'
        ];
        const nodes = [];
        selectors.forEach((sel) => container.querySelectorAll(sel).forEach((n) => nodes.push(n)));
        return nodes;
      }

      setDisplayedPriceFromCents(totalCents) {
        const nodes = this.getPriceNodes();
        if (!nodes.length) return;
        let formatted;
        try {
          formatted = window.Shopify && typeof window.Shopify.formatMoney === 'function'
            ? window.Shopify.formatMoney(totalCents)
            : (totalCents / 100).toLocaleString(undefined, { style: 'currency', currency: (Shopify?.currency?.active || 'USD') });
        } catch (e) {
          formatted = (totalCents / 100).toFixed(2);
        }
        nodes.forEach((n) => { n.textContent = formatted; });
      }

      // Only update the main price element(s) with id "price_item_price" within .includeAllPrice
      setMainDisplayedPriceFromCents(totalCents) {
        const container = this.querySelector('.includeAllPrice');
        if (!container) return;
        const nodes = container.querySelectorAll('#price_item_price');
        if (!nodes || nodes.length === 0) return;
        let formatted;
        try {
          formatted = window.Shopify && typeof window.Shopify.formatMoney === 'function'
            ? window.Shopify.formatMoney(totalCents)
            : (totalCents / 100).toLocaleString(undefined, { style: 'currency', currency: (Shopify?.currency?.active || 'USD') });
        } catch (e) {
          formatted = (totalCents / 100).toFixed(2);
        }
        nodes.forEach((n) => {
          if (n && n.id === 'price_item_price') n.textContent = formatted;
        });
      }

      // Compute and display combined price: current variant price + signature add-on (if active) + paper quality (if selected)
      updateCombinedDisplayedPrice(variant) {
        try {
          if (!variant) {
            console.log('updateCombinedDisplayedPrice: No variant provided');
            return;
          }
          
          let total = Number(variant.price || 0);
          console.log('updateCombinedDisplayedPrice: Base variant price:', total);

          // Add signature product price if checked
          const signatureChk = document.querySelector('#signatureProduct');
          if (signatureChk && signatureChk.checked) {
            const centsAttr = signatureChk.getAttribute('data-productprice-cents');
            let signatureCents = centsAttr ? Number(centsAttr) : 0;
            if (!centsAttr) {
              const moneyStr = signatureChk.getAttribute('data-productprice') || '';
              signatureCents = this.parseMoneyToCents(moneyStr);
            }
            if (!Number.isNaN(signatureCents) && signatureCents > 0) {
              total += signatureCents;
              console.log('updateCombinedDisplayedPrice: Added signature price:', signatureCents, 'Total:', total);
            }
          }

          // Add paper quality price if checked
          // Try to find paper elements within this element first, then document-wide
          let paperElements = this.querySelectorAll('product-quality_paper');
          if (paperElements.length === 0) {
            paperElements = document.querySelectorAll('product-quality_paper');
          }
          
          console.log('updateCombinedDisplayedPrice: Found paper elements:', paperElements.length);
          
          paperElements.forEach((paper) => {
            const checkedPaper = paper.querySelector('.paper_product_selected:checked');
            if (checkedPaper) {
              // Get the new price (which includes quantity multiplier)
              // data-productpriceNew is stored in dollars (price was divided by 100)
              const paperPriceNew = Number(checkedPaper.getAttribute('data-productpriceNew')) || 0;
              console.log('updateCombinedDisplayedPrice: Found checked paper, priceNew:', paperPriceNew);
              // Convert from dollars to cents (multiply by 100) to match variant.price format
              const paperPriceCents = paperPriceNew * 100;
              if (!Number.isNaN(paperPriceCents) && paperPriceCents > 0) {
                total += paperPriceCents;
                console.log('updateCombinedDisplayedPrice: Added paper price:', paperPriceCents, 'Total:', total);
              }
            }
          });

          // console.log('updateCombinedDisplayedPrice: Final total:', total);
          this.setMainDisplayedPriceFromCents(total);
        } catch (e) {
          console.error('Failed to update combined price', e);
        }
      }

      // Best-effort money string to cents parser (handles $1,234.56 and 1.234,56 by stripping non-digits)
      parseMoneyToCents(moneyStr) {
        if (!moneyStr || typeof moneyStr !== 'string') return 0;
        const digits = moneyStr.replace(/[^0-9]/g, '');
        if (!digits) return 0;
        // Interpret last 2 digits as cents
        const value = Number(digits);
        if (Number.isNaN(value)) return 0;
        return value;
      }

      // Initialize paper quantities handler - handles quantity dropdown changes
      initPaperQuantitiesHandler() {
        // Clean up any existing handlers first
        this.cleanupPaperQuantitiesHandler();

        // Find and bind the quantity dropdown
        this.bindQuantityDropdown();

        // Set up MutationObserver to rebind when DOM changes (e.g., variant swaps)
        this.quantityDropdownObserver = new MutationObserver((mutations) => {
          let dropdownChanged = false;

          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === 1 &&
                node.querySelector &&
                node.querySelector('.quantity_selector_dropdown')
              ) {
                dropdownChanged = true;
              }
            });
          });

          if (dropdownChanged) {
            setTimeout(() => {
              this.bindQuantityDropdown();
            }, 50);
          }
        });

        // Observe changes within this product-info element only
        this.quantityDropdownObserver.observe(this, {
          childList: true,
          subtree: true,
        });
      }

      // Update paper quantities based on selected dropdown value
      updatePaperQuantities() {
        const quantityDropdown = this.querySelector('.quantity_selector_dropdown');
        if (!quantityDropdown) return;

        const selectedValue = quantityDropdown.value;
        // Try to find paper elements within this element first, then document-wide
        let paperElements = this.querySelectorAll('product-quality_paper');
        if (paperElements.length === 0) {
          paperElements = document.querySelectorAll('product-quality_paper');
        }

        paperElements.forEach((paper) => {
          const checkboxes = paper.querySelectorAll('.paper_product_selected');

          checkboxes.forEach((checkbox) => {
            // Get original price (store it if not already stored)
            if (!checkbox.hasAttribute('data-original-price')) {
              const currentPrice = Number(checkbox.getAttribute('data-productprice')) || 0;
              checkbox.setAttribute('data-original-price', currentPrice);
            }

            // Update quantity attribute
            if (selectedValue) {
              checkbox.setAttribute('data-quantity', selectedValue);
            } else {
              checkbox.setAttribute('data-quantity', 1);
            }

            // Calculate and update price with quantity
            const originalPrice = Number(checkbox.getAttribute('data-original-price')) || 0;
            const quantity = Number(checkbox.getAttribute('data-quantity')) || 1;
            const priceWithQty = originalPrice * quantity;

            // Set new price attribute without overwriting the original
            checkbox.setAttribute('data-productpriceNew', priceWithQty);
          });
        });

        // Update combined price if any paper checkbox is checked
        const variant = this.getSelectedVariant(document);
        if (variant) {
          this.updateCombinedDisplayedPrice(variant);
        }
      }

      // Bind quantity dropdown event listener
      bindQuantityDropdown() {
        const newDropdown = this.querySelector('.quantity_selector_dropdown');
        if (!newDropdown || newDropdown === this.currentQuantityDropdown) return;

        // Remove old listener if exists
        if (this.currentQuantityDropdown && this.quantityDropdownListener) {
          this.currentQuantityDropdown.removeEventListener('change', this.quantityDropdownListener);
        }

        // Create bound listener function
        this.quantityDropdownListener = this.updatePaperQuantities.bind(this);

        // Add new listener
        newDropdown.addEventListener('change', this.quantityDropdownListener);
        this.currentQuantityDropdown = newDropdown;

        // Initialize with current value
        this.updatePaperQuantities();
      }

      // Cleanup paper quantities handler
      cleanupPaperQuantitiesHandler() {
        if (this.currentQuantityDropdown && this.quantityDropdownListener) {
          this.currentQuantityDropdown.removeEventListener('change', this.quantityDropdownListener);
          this.currentQuantityDropdown = null;
          this.quantityDropdownListener = null;
        }

        if (this.quantityDropdownObserver) {
          this.quantityDropdownObserver.disconnect();
          this.quantityDropdownObserver = null;
        }
      }

      // Initialize signature checkbox handler - handles signature product price updates
      initSignatureCheckboxHandler() {
        // Clean up any existing handler first
        this.cleanupSignatureCheckboxHandler();

        const signatureChk = this.querySelector('#signatureProduct') || document.querySelector('#signatureProduct');
        if (!signatureChk) return;

        // Create bound listener function
        this.signatureCheckboxListener = () => {
          const variant = this.getSelectedVariant(document);
          if (variant) {
            this.updateCombinedDisplayedPrice(variant);
          }
        };

        // Add event listener (use once: false to allow multiple calls)
        signatureChk.addEventListener('change', this.signatureCheckboxListener);
      }

      // Cleanup signature checkbox handler
      cleanupSignatureCheckboxHandler() {
        const signatureChk = document.querySelector('#signatureProduct');
        if (signatureChk && this.signatureCheckboxListener) {
          signatureChk.removeEventListener('change', this.signatureCheckboxListener);
          this.signatureCheckboxListener = null;
        }
      }

      // Initialize paper checkbox handlers - handles paper quality selection and price updates
      initPaperCheckboxHandlers() {
        // Clean up any existing handlers first
        this.cleanupPaperCheckboxHandlers();

        // Try to find paper elements within this element first, then document-wide
        let paperElements = this.querySelectorAll('product-quality_paper');
        if (paperElements.length === 0) {
          paperElements = document.querySelectorAll('product-quality_paper');
        }
        
        paperElements.forEach((paper) => {
          const checkboxes = paper.querySelectorAll('.paper_product_selected');
          
          checkboxes.forEach((checkbox) => {
            // Create bound listener function for price update
            const priceUpdateListener = () => {
              // Handle single selection (only one checkbox can be checked at a time)
              if (checkbox.checked) {
                checkboxes.forEach((cb) => {
                  if (cb !== checkbox) cb.checked = false;
                });
              }

              // Update combined price when checkbox state changes
              const variant = this.getSelectedVariant(document);
              if (variant) {
                this.updateCombinedDisplayedPrice(variant);
              }
            };

            // Add event listener
            checkbox.addEventListener('change', priceUpdateListener);
            
            // Store listener reference for cleanup
            this.paperCheckboxListeners.push({
              checkbox: checkbox,
              listener: priceUpdateListener
            });
          });
        });
      }

      // Cleanup paper checkbox handlers
      cleanupPaperCheckboxHandlers() {
        this.paperCheckboxListeners.forEach(({ checkbox, listener }) => {
          checkbox.removeEventListener('change', listener);
        });
        this.paperCheckboxListeners = [];
      }
    }
  );
}


  